module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row edit-location-other-info"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.columnOne(_vm.value)), function(addPropArg, index) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "locationPhotoURL"
      }
    }, [_vm._v(_vm._s(addPropArg.propertyID))]), _vm._v(" "), (!_vm.propSpec(addPropArg.propertyID)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addPropArg.value),
        expression: "addPropArg.value"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (addPropArg.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addPropArg, "value", $event.target.value)
        }
      }
    }) : (_vm.propSpec(addPropArg.propertyID).type === 'String') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addPropArg.value),
        expression: "addPropArg.value"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (addPropArg.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addPropArg, "value", $event.target.value)
        }
      }
    }) : (_vm.propSpec(addPropArg.propertyID).type === 'Date') ? _c('datepicker', {
      attrs: {
        "date_format": _vm.propSpec(addPropArg.propertyID).format,
        "value": _vm.genDate(addPropArg.value, _vm.propSpec(addPropArg.propertyID).format),
        "index": addPropArg.propertyID
      },
      on: {
        "updated": function($event) {
          _vm.updatedDate($event, _vm.propSpec(addPropArg.propertyID).format)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addPropArg.value),
        expression: "addPropArg.value"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (addPropArg.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addPropArg, "value", $event.target.value)
        }
      }
    })], 1)])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.columnTwo(_vm.value)), function(addPropArg, index) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "locationPhotoURL"
      }
    }, [_vm._v(_vm._s(addPropArg.propertyID))]), _vm._v(" "), (!_vm.propSpec(addPropArg.propertyID)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addPropArg.value),
        expression: "addPropArg.value"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (addPropArg.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addPropArg, "value", $event.target.value)
        }
      }
    }) : (_vm.propSpec(addPropArg.propertyID).type === 'String') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addPropArg.value),
        expression: "addPropArg.value"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (addPropArg.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addPropArg, "value", $event.target.value)
        }
      }
    }) : (_vm.propSpec(addPropArg.propertyID).type === 'Date') ? _c('datepicker', {
      attrs: {
        "date_format": _vm.propSpec(addPropArg.propertyID).format,
        "value": _vm.genDate(addPropArg.value, _vm.propSpec(addPropArg.propertyID).format),
        "index": addPropArg.propertyID
      },
      on: {
        "updated": function($event) {
          _vm.updatedDate($event, _vm.propSpec(addPropArg.propertyID).format)
        }
      }
    }) : _vm._e()], 1)])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8ec488"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/additional-props.vue
// module id = 545
// module chunks = 1